import { NorthEastOutlined } from "@mui/icons-material";
import { Box, Typography, Button } from "@mui/material";
import React from "react";

export const OverviewCard = ({
  title = "",
  value = "",
  icon,
  extraValue = "",
  extraColor,
  showButton = false,
  onViewClick = () => {},
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "flex-start",
        borderRight: "1px solid #f0f0f0",
        padding: "12px",
        backgroundColor: "#ffffff",
        borderRadius: "10px",
      }}
    >
      <Box>
        <Typography variant="caption" style={{ color: "#B9B9B9" }}>
          {title}
        </Typography>
        <Typography variant="h6" style={{ fontWeight: 600 }}>
          {value}
          {extraValue && (
            <>
              <NorthEastOutlined sx={{ fontSize: "1rem", color: extraColor }} />
              <Typography variant="caption" sx={{ color: extraColor }}>
                {extraValue}
              </Typography>
            </>
          )}
        </Typography>
      </Box>
      <Box display="flex" flexDirection="column" alignItems="center">
        {icon}
        {showButton && (
          <Button
            variant="text"
            size="small"
            sx={{
              fontSize: "0.7rem",
              padding: "2px 6px",
              marginTop: 1,
              color: "#783DC4",
              fontWeight: 600,
            }}
            onClick={onViewClick}
          >
            View
          </Button>
        )}
      </Box>
    </Box>
  );
};
